export class GoOffCanvasOptions {
  /**
   * The header text for the Off Canvas.
   */
  header?: string = '';
  /**
   * The width of the Off Canvas.
   */
  size?: 'large' | 'small' = 'small';
}
